import { render, staticRenderFns } from "./DownloadLink.vue?vue&type=template&id=4fdd7a50"
import script from "./DownloadLink.vue?vue&type=script&lang=ts"
export * from "./DownloadLink.vue?vue&type=script&lang=ts"
import style0 from "./DownloadLink.vue?vue&type=style&index=0&id=4fdd7a50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports